import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Loader2, Lock } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Store token in localStorage
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminEmail', formData.email);
        navigate('/admin');
      } else {
        setError(data.detail || 'Invalid credentials');
      }
    } catch (err) {
      setError('Unable to connect. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="bg-black min-h-screen pt-24 lg:pt-32 flex items-center justify-center">
      <div className="w-full max-w-md px-6">
        <div className="bg-white/[0.02] border border-white/10 p-8 lg:p-12">
          {/* Header */}
          <div className="text-center mb-10">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-[#7B1818] to-[#4A0E0E] rounded-full flex items-center justify-center">
              <Lock size={28} className="text-white" />
            </div>
            <h1 className="font-serif text-3xl text-white tracking-tight">
              Admin Login
            </h1>
            <p className="font-sans text-sm text-white/50 mt-2">
              Sign in to access the dashboard
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="font-sans text-[11px] tracking-[0.15em] uppercase text-white/40 block mb-3">
                Email
              </label>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="bg-transparent border-white/20 text-white placeholder:text-white/30 focus:border-white/50 rounded-none h-12 font-sans text-sm"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="font-sans text-[11px] tracking-[0.15em] uppercase text-white/40 block mb-3">
                Password
              </label>
              <Input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="bg-transparent border-white/20 text-white placeholder:text-white/30 focus:border-white/50 rounded-none h-12 font-sans text-sm"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="p-4 bg-red-900/20 border border-red-500/30 text-red-300 text-sm">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full h-14 bg-gradient-to-r from-[#7B1818] to-[#4A0E0E] hover:from-[#8B2020] hover:to-[#5A1010] text-white font-sans text-[11px] tracking-[0.2em] uppercase rounded-none disabled:opacity-50"
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  Signing in...
                </span>
              ) : (
                'Sign In'
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
